/**
 * Shared helpers for interpreting the `analysisType` value returned by the API.
 *
 * The backend has returned both 'multi-page' (legacy) and 'multi' (current)
 * for multi-page scans, so every UI check must accept both values. Use
 * `isMultiPageAnalysis` instead of comparing against a single literal.
 */

/** All analysis type values seen from the API, legacy and current. */
export type AnalysisTypeValue = 'single' | 'multi' | 'multi-page'

/**
 * True when the given analysis type represents a multi-page analysis.
 * Accepts 'multi' and 'multi-page' (case/whitespace tolerant); anything
 * else — including 'single' and undefined — is treated as single-page.
 */
export const isMultiPageAnalysis = (analysisType?: string | null): boolean => {
  if (!analysisType) return false
  const normalised = analysisType.trim().toLowerCase()
  return normalised === 'multi' || normalised === 'multi-page'
}
